module.exports = __webpack_public_path__ + "img/logo_bg.be0f5d43.png";